angular.module("app").controller("PagesPageController", [
    '$scope',
    function ($scope) {

    }
]);